import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconInfo = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_12_24874)">
          <path
            d="M10.0052 18.3337C14.6076 18.3337 18.3385 14.6027 18.3385 10.0003C18.3385 5.39795 14.6076 1.66699 10.0052 1.66699C5.40284 1.66699 1.67188 5.39795 1.67188 10.0003C1.67188 14.6027 5.40284 18.3337 10.0052 18.3337Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13.3333V10"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 6.66699H10.0083"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_12_24874">
            <rect width={width} height={height} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgWrapper>
  );
};
